import { parseHTMLToDoc } from "@smartsuite/smartdoc/lib/esm/helpers/parsers";
import type { FieldRegistryConfig } from "../../types";
import { smartdocToReviewString } from "../review/reviewString.helpers";
import type { SmartdocDocument } from "./SmartdocFieldControl/Smartdoc";
import { SmartdocFieldControl } from "./SmartdocFieldControl/SmartdocFieldControl";

export interface SmartdocFieldValue {
  data: SmartdocDocument;
}

export const smartdocFieldConfig: FieldRegistryConfig<SmartdocFieldValue> = {
  icon: "smartdoc",
  control: SmartdocFieldControl,
  prefill: ({ value }) => {
    return {
      data: parseHTMLToDoc(value),
    };
  },
  toReviewString: (value) => smartdocToReviewString(value),
};
